// @flow

import React from 'react';

import {
  withTypedRouter,
  type WithRouterProps,
} from 'app/general/withTypedRouter';
import {
  DashboardFilterbar,
  applyFilter,
} from 'app/general/dashboards/DashboardFilterbar';
import {SearchInputField} from 'app/general/widgets/SearchInputField';
import type {TagsDashboardLocationParamsType} from 'app/tags/types';

type RouterProps = WithRouterProps<TagsDashboardLocationParamsType>;

type OwnProps = {|
  viewingAll: boolean,
  resetFilters: () => void,
|};

type Props = {|
  ...OwnProps,
  ...RouterProps,
|};

class BaseTagsFilterbar extends React.PureComponent<Props> {
  onSearch = (search) => {
    this.applyFilter('search', search);
  };

  applyFilter(key, value) {
    const {router, location} = this.props;
    return applyFilter(router, location, {[key]: value});
  }

  render() {
    const {resetFilters, viewingAll} = this.props;
    const {query} = this.props.location;

    return (
      <DashboardFilterbar resetFilters={resetFilters} viewingAll={viewingAll}>
        <div className="col">
          <SearchInputField
            value={query.search != null ? query.search : ''}
            onChange={this.onSearch}
          />
        </div>
      </DashboardFilterbar>
    );
  }
}

export const TagsFilterbar = withTypedRouter<OwnProps, RouterProps>(
  BaseTagsFilterbar
);
